/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import complexprg95grpexample_IconURL from './Typescript_logo.png';
import complexprg95grpexample_InsetIconURL from './typescript-logo.svg';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default {
	name: 
  (
    <FormattedMessage
        defaultMessage="Realistic Typescript-Based Extension"
        description="name for the Realistic Typescript-Based Extension extension"
        id="extension.complexprg95grpexample.name"
    />
  ),
	description: 
  (
    <FormattedMessage
        defaultMessage="Demonstrating how typescript can be used to write a realistic extension"
        description="description for the Realistic Typescript-Based Extension extension"
        id="extension.complexprg95grpexample.description"
    />
  ),
	iconURL: complexprg95grpexample_IconURL,
	insetIconURL: complexprg95grpexample_InsetIconURL,
	tags: ["PRG Internal"],
	featured: true,
	extensionId: 'complexprg95grpexample',
}